import {IJobListActionTypes,IJobListActionCreator,IJobListState} from 'models/IJobListsState';

const initialState:IJobListState[] = []

const reducer = (state = initialState, { type, payload }: IJobListActionCreator) => {
    switch (type) {
      case IJobListActionTypes.FETCH_JOB_LIST_DETAILS_REQUEST:
        return {
          ...state,
          data:{},
        }
      case IJobListActionTypes.FETCH_JOB_LIST_DETAILS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  };
  
  export default reducer;